<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main">
        <SubTitleComponent :title="title"></SubTitleComponent>
        <div class="box">
          <el-row :gutter="10" v-if="global.type == 'manage'" class="tools">
            <el-col :span="4" :offset="16">
              <el-button type="success" @click="toPath('/customernew')" plain>编辑客户信息</el-button>
            </el-col>
            <el-col :span="4">
              <el-button type="success" @click="toDelete" plain>删除客户</el-button>
            </el-col>
          </el-row>
          <el-descriptions title="" direction="vertical" :column="global.type == 'manage' ? 5 : 6" border>
            <el-descriptions-item label="行业类型">{{ customerData.industry_type }}</el-descriptions-item>
            <el-descriptions-item label="项目类型">{{ customerData.project_type }}</el-descriptions-item>
            <el-descriptions-item label="项目面积">{{ customerData.project_area }}平方米</el-descriptions-item>
            <el-descriptions-item label="项目联系人">{{ customerData.contact_neme }}</el-descriptions-item>
            <el-descriptions-item label="联系方式">{{ customerData.contact_phone }}</el-descriptions-item>
            <el-descriptions-item label="更多" v-if="global.type == 'client'" labelStyle="width:20%;"><el-button @click="toPath('/effectcollect')">查看收藏</el-button></el-descriptions-item>
          </el-descriptions>
          <div v-if="renderData.length > 0" v-for="(item, index) in renderData" :key="item.id" class="spaceBox">
            <div class="spaceName">{{ item.space_type+'('+item.count+'张)' }}</div>
            <div class="date">{{ item.date }}</div>
            <el-divider></el-divider>
            <div class="modelBox" v-for="(itemM, indexM) in item.model">
              <div class="modelName">{{ itemM.model_name+'('+itemM.count+'张)' }}</div>
              <div class="mediaF" v-for="(itemW, indexW) in itemM.workblank">
                <div class="mediaBox">
                  <div class="item">
                    <img :src="itemW.photo_url" alt="">
                    <div class="mediaName">毛坯图</div>
                  </div>
                  <div class="item" v-for="(itemS, indexS) in itemW.effect_result" @click="toDetail(index,indexM,indexW,indexS)">
                    <img v-if="itemS.file_type == 0" :src="itemS.file_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'" alt="">
                    <video v-if="itemS.file_type == 1" :src="itemS.file_url" alt="" :poster="itemW.photo_url + '?x-oss-process=image/resize,m_fill,w_1000,h_1000'"></video>
                    <div class="type">{{ itemS.file_type == 0 ? '生成效果图' : itemS.file_type == 1 ? '图生视频' : 'AI改图' }}</div>
                    <div v-if="itemS.file_type == 1" class="play"><img src="../../assets/ico_play.png" alt=""></div>
                    <div class="mediaName"></div>
                  </div>
                </div>
                <el-divider v-if="indexM != item.model.length -1"></el-divider>
              </div>
            </div>
          </div>
          <div class="list" v-if="renderData.length <= 0">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
        <el-dialog
          :visible.sync="dialogVisit"
          width="60%"
          :show-close="true"
          center>
          <div class="img" v-if="dialogCur[0] != -1">
            <img v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 0" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" alt="">
            <video v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_type == 1" :src="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].file_url" :poster="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].photo_url" alt="" controls></video>
          </div>
          <span slot="footer" class="dialog-footer" v-if="dialogCur[0] != -1">
            <!-- <el-button @click="toCancel">返回</el-button> -->
            <!-- <el-button @click="toPath('/effectsave')">生成新的效果图</el-button> -->
            <el-button v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].workblank_id == 0" type="success" @click="toPath('/effectvideo')" plain>图生视频</el-button>
            <el-button v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].workblank_id == 0" type="success" @click="toPath('/effectaiedit')" plain>AI改图</el-button>
            <el-button v-if="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].workblank_id == 0" type="success" @click="toFavorite" :icon="renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].favorite == 0 ? 'el-icon-star-off' : 'el-icon-star-on'" plain>{{ renderData[dialogCur[0]].model[dialogCur[1]].workblank[dialogCur[2]].effect_result[dialogCur[3]].favorite == 0 ? '收藏' : '取消收藏' }}</el-button>
            <el-button type="success" @click="toDownload" plain>下载</el-button>
          </span>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>
  
<script>
let _ajaxType = 0

const imgDemo = require('../../assets/pic_xgt.jpg')

import { apiDownload } from '@/utils/download';

const renderData = [{
  id: '1',
  space_type: '前厅',
  count: '2',
  date: '2025-05-15',
  model: [{
    ai_model: '大模型A',
    count: '4',
    workblank: [{
      photo_url: imgDemo,
      effect_result: [{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      }]
    },{
      photo_url: imgDemo,
      effect_result: [{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      }]
    }]
  },
  {
    ai_model: '大模型B',
    count: '4',
    workblank: [{
      photo_url: imgDemo,
      effect_result: [{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      }]
    }]
  }],
},
{
  id: '2',
  space_type: '工位',
  count: '2',
  date: '2025-05-15',
  model: [{
    ai_model: '大模型A',
    count: '4',
    workblank: [{
      photo_url: imgDemo,
      effect_result: [{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      }]
    }]
  },
  {
    ai_model: '大模型B',
    count: '4',
    workblank: [{
      photo_url: imgDemo,
      effect_result: [{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      },{
        file_url: imgDemo,
        file_type: 0
      }]
    }]
  }],
}]

export default {
  name: 'CustomerDetail',
  components: {},
  data() {
    return {
      id: 0,
      title: '',
      customerData: {},
      renderData: [],
      dialogVisible: '',
      dialogVisit: false,
      dialogCur: [-1, -1, -1, -1],
      favoriteType: true,
      page: 0,
      pagesize: 10,
      allpage: 0
    }
  },
  created() {
    console.log(this.$route.params.id); // 打印出 URL 中的 id 参数
    let _id = this.$route.params.id
    this.id = _id
    this.getData()
  },
  mounted() {
    _ajaxType = 0
    // this.renderData = renderData
  },
  methods: {
    handleDetal(index, row) {
      console.log(index, row);
    },
    getData() {
      this.getInfo()
      this.getEffect()
    },
    getInfo(){
      let _id = this.id
      let _url = "/api/?mod=client&action=detail"
      let _clientData = {
        client_id: _id
      }
      // console.log(this.axios)
      this.axios.post(_url, _clientData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("clientInfo", _data);
        if (json.data.errcode == 0) {
          this.customerData = _data
          this.title = _data.client_name
        }
        console.log(json.data);
      })
    },
    getEffect() {
      if(_ajaxType == 1) return
      let _page = this.page
      let _allpage = this.allpage
      console.log(_page, _allpage)
      if(_allpage <= 0 || _page < _allpage){
        _ajaxType = 1
        let _id = this.id
        let _url = "/api/?mod=client&action=effect"
        let _clientData = {
          client_id: _id,
          page: _page + 1,
          pagesize: this.pagesize,
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          _ajaxType = 0
          // 获取
          let _data = json.data.data
          console.log("effectInfo", _data);
          if (json.data.errcode == 0) {
            this.renderData = [...this.renderData, ..._data.result]
          }
          console.log(json.data);
        })
      }
    },
    toDetail(cur,curM,curW,curS) {
      this.dialogCur = [cur, curM, curW, curS]
      // this.dialogVisible = 'detail'
      this.dialogVisit = true
    },
    toPath(path) {
      if(path == '/customernew'){
        let _info = JSON.stringify(this.customerData)
        console.log('toNew', _info)
        localStorage.setItem('customerInfo', _info)
      }
      if(path == '/effectvideo' || path == '/effectaiedit'){
        let _render = this.renderData
        let _curData = this.dialogCur
        let _photo = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].file_url
        // let _style = this.detailData.style_type
        let _space = _render[_curData[0]].space_type
        localStorage.setItem('effect_url', _photo)
        localStorage.setItem('effect_space', _space)
      }
      this.$router.push({ path: path })
    },
    toCancel() {
      // this.dialogVisible = ''
      this.dialogVisit = false
    },
    toFavorite() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _url = "/api/?mod=effect_favorite&action=add"
      let _render = [...this.renderData]
      let _curData = this.dialogCur
      let _id = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].effect_result_id
      let _type = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].favorite
      let _favoriteData = {
        effect_result_id: _id
      }
      if(_type == 1){
        _url = "/api/?mod=effect_favorite&action=cancel"
        _id = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].effect_favorite_id
        _favoriteData = {
          effect_favorite_id: _id
        }
      }
      console.log(_favoriteData)
      this.axios.post(_url, _favoriteData).then(json => {
        // 获取
        _ajaxType = 0
        let _data = json.data.data
        console.log("favoriteData", _data);
        if (json.data.errcode == 0) {
          let _content = '收藏成功'
          if(_type == 0){
            _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].favorite = 1
            _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].effect_favorite_id = _data.effect_favorite_id
            // this.favoriteId = _data.effect_favorite_id
          }
          if(_type == 1){
            _content = '取消成功'
            _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].favorite = 0
          }
          this.renderData = _render
          this.$message({
            message: _content,
            type: 'success',
            offset: 300,
            onClose: function() {
            }
          });
        }
        console.log(json.data);
      })
    },
    toDownload() {
      const link = document.createElement('a')
      let _render = this.renderData
      let _curData = this.dialogCur
      let _type = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].file_type // 替换为你的图片 URL
      // let _type = _render[_cur].effect_result[0].file_type
      let _href = ''
      if(_type == 0){
        let _img = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].file_url
        if (_img.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://oss.ylw.s136.ailo.vip', '/ai_images');
        }
        if (_img.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _img.replace('https://aigc.oss.ylwai.cn', '/ai2_images');
        }
      }
      if(_type == 1){
        let _video = _render[_curData[0]].model[_curData[1]].workblank[_curData[2]].effect_result[_curData[3]].file_url
        if (_video.startsWith('https://oss.ylw.s136.ailo.vip')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://oss.ylw.s136.ailo.vip', '/ai_videos');
        }
        if (_video.startsWith('https://aigc.oss.ylwai.cn')) {
          // 移除 '/api/' 前缀
          _href = _video.replace('https://aigc.oss.ylwai.cn', '/ai2_videos');
        }
      }
      console.log('href',_href)
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      apiDownload(
        _href
      )
    },
    toDelete() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      this.$confirm('此操作将删除该客户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let _id = this.id
        let _url = "/api/?mod=client&action=delete"
        let _clientData = {
          client_id: _id
        }
        // console.log(this.axios)
        this.axios.post(_url, _clientData).then(json => {
          _ajaxType = 0
          // 获取
          let _data = json.data.data
          console.log("clientInfo", _data);
          if (json.data.errcode == 0) {
            this.$message({
              message: '删除成功',
              type: 'success',
              offset: 300,
              onClose: function() {
                _this.$router.go(-1);
              }
            });
          }
          console.log(json.data);
        })
      }).catch(() => {
        _ajaxType = 0 
      });
    }
  }
}
</script>
  
<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  padding-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  .box {
    min-height: calc(100vh - 154px);
    padding: 20px;
    background: #fff;
    box-sizing: border-box;
    .tools {
      margin-bottom: 20px;
      h4 {
        // margin-bottom: 8px;
        // padding-left: 12px;
        background: #fff;
        color: rgb(16, 16, 16);
        font-size: 20px;
        font-weight: 400;
        line-height: 2em;
      }
      .el-button {
        width: 100%;
      }
    }
    .renderLabel {
      width: 100px;
    }
    .spaceBox {
      position: relative;
      margin-top: 20px;
      padding: 20px;
      border: 1px solid #DCDFE6;
      border-radius: 10px;
      .spaceName {
        font-size: 24px;
        color: rgba(10,10,10,1);
        line-height: 40px;
      }
      .date {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 12px;
        color: rgba(10,10,10,0.6);
        line-height: 40px;
      }
      .modelBox {
        .modelName {
          font-size: 18px;
          color: rgba(10,10,10,1);
          line-height: 32px;
        }
        .mediaBox {
          margin-top: 10px;
          display: grid;
          // flex-wrap: wrap;
          // justify-content: space-between;
          grid-template-columns: repeat(5, 1fr);
          // padding-inline-start: 0;
          gap: 20px;
          // padding: 0 30px;
          vertical-align: top;
          .item {
            position: relative;
            // flex: 0 0 calc(30%);
            // gap: 20px;
            // padding: 10px;
            // background: #fff;
            // border: 1px dashed rgb(187, 187, 187);
            // border-radius: 5px;
            font-size: 0;
            box-sizing: border-box;
            img {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
            video {
              width: 100%;
              aspect-ratio: 1 / 1; /* 宽高比为 1:1 */
              object-fit: cover;
            }
            .mediaName {
              min-height: 20px;
              padding: 10px;
              color: rgba(10,10,10,1);
              font-size: 14px;
              line-height: 20px;
              text-align: center;
            }
            .play {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              padding: 30px;
              aspect-ratio: 1 / 1;
              /* background: url(../../assets/ico_play.png) no-repeat;
              background-position: center center;
              background-size: 60%; */
              box-sizing: border-box;
              z-index: 1001;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .type {
              position: absolute;
              top: 0;
              right: 0;
              padding: 5px 10px;
              background-color: #50b85c;
              border-bottom-left-radius: 5px;
              color: #fff;
              font-size: 14px;
              z-index: 1002;
            }
          }
        }
      }
    }
  }
}
.el-dialog {
  .img {
    text-align: center;
    img {
      max-width: 100%;
      max-height: 300px;
    }
    video {
      max-width: 100%;
      max-height: 300px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Customer/Detail.vue